// Single decision for the "Choose your plan" onboarding gate.
//
// A user with an active paid plan (incl. admin comps) is never sent to plan
// selection, even if their onboarding record never logged a pick — admin
// invites and comps create the subscription without that step. Free-plan
// users still must pick, since every signup starts on a default free row.
import { resolveEffectivePlanKey, type EffectivePlanSource } from "./effectivePlan";

interface GateSubscription extends EffectivePlanSource {
  status?: string | null;
  current_period_end?: string | null;
}

export function hasActivePlan(sub: GateSubscription | null | undefined, now: Date = new Date()): boolean {
  if (!sub) return false;
  if (sub.status === "active" || sub.status === "trialing") return true;
  const end = sub.current_period_end ? new Date(sub.current_period_end).getTime() : null;
  return end !== null && end > now.getTime();
}

export function needsPlanSelection(
  progress: { plan_selected?: boolean | null } | null | undefined,
  sub: GateSubscription | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!hasActivePlan(sub, now)) return true;
  if (progress?.plan_selected) return false;
  return resolveEffectivePlanKey(sub, now) === "free";
}
